import React from 'react';

export default function InfertilityEvaluation() {
  return (
    <main className="section-container py-12">
      <div className="space-y-8">
        <section>
          <h1 className="text-4xl font-bold text-brand mb-6">
            Infertility Evaluation
          </h1>
          <p className="text-lg text-neutral/70 leading-relaxed">
            Infertility is stressful condition. While it is not considered a disease, it causes lot of mental and psychological upheavals. It also leads to social isolation and withdrawal especially in traditional societies.
          </p>
          <p className="text-lg text-neutral/70 leading-relaxed mt-4">
            'To get and to beget' is an inborn human tendency and when couples find it difficult to procreate, they must see Reproductive Medicine specialist. Evaluation is always done as a couple irrespective of who has the problem, so it is important for both husband and wife to see the doctor.
          </p>
          <p className="text-lg text-neutral/70 leading-relaxed mt-4">
            The first step in evaluation is the history where the doctor will enquire in detail regarding the menstrual history, medical and surgical history and also the detailed history of male partner.
          </p>
          <p className="text-lg text-neutral/70 leading-relaxed mt-4">
            The first investigation, which is usually done, is a semen analysis of the husband. We always do a transvaginal sonography of the female partner to assess the condition of uterus and ovaries.
          </p>
          <p className="text-lg text-neutral/70 leading-relaxed mt-4">
            A thyroid test and assessment of prolactin levels and Rubella immunity is also done in almost all females.
          </p>
          <p className="text-lg text-neutral/70 leading-relaxed mt-4">
            After the result of these tests is ready, the doctor will formulate a treatment plan for your case taking into consideration all the clinical features of your case. Dr. Priya believes in individualizing the treatment and you will not find the assembly line or cookie cutter approach in our clinic.
          </p>
        </section>
      </div>
    </main>
  );
}
